import moment from "moment";
import { HOLIDAYS_JP } from "../constants/Constants";

// デフォルトでレター作成着手にかかる営業日
const DEFAULT_ORDER_WAITING_NUMBER_OF_BUSINESS_DAYS = 1;
// デフォルトでレター作成から印刷所に渡す日数
const DEFAULT_PROOFREAD_CREATING_NUMBER_OF_BUSINESS_DAYS = 2;
// デフォルトで印刷所からレターが発送されるまでにかかる日数
const DEFAULT_PRINTING_NUMBER_OF_BUSINESS_DAYS = 1;
// 注文状況が混雑している場合、印刷所からレターが発送されるまでにかかる日数で、加算される最大日数
const ADD_MAX_PRINTING_NUMBER_OF_BUSINESS_DAYS_FOR_CONGESTION = 3;
// 大量注文と判定する通数の境界数
const MIN_ORDER_ADDRESS_COUNT_AT_LETTER_ORDER = 10000;
// 大量注文の場合印刷所からレターが発送されるまでにかかる日数で、加算される日数
const ADD_PRINTING_NUMBER_OF_BUSINESS_DAYS_FOR_BULK_LETTER_ORDER = 6;

/**
 * 発送済みまでの最小営業日数
 * @return {int}
 */
export const getMinBusinessDaysUntilShippingSchedule = () => {
  return DEFAULT_ORDER_WAITING_NUMBER_OF_BUSINESS_DAYS +
          DEFAULT_PROOFREAD_CREATING_NUMBER_OF_BUSINESS_DAYS +
          DEFAULT_PRINTING_NUMBER_OF_BUSINESS_DAYS;
}

/**
 * 発送済みまでの最大営業日数
 * @param {int} currentOrderAddressCount
 * @returns {int}
 */
export const getMaxBusinessDaysUntilShippingSchedule = (currentOrderAddressCount) => {
  let totalBusinessDays = getMinBusinessDaysUntilShippingSchedule();

  if (currentOrderAddressCount >= MIN_ORDER_ADDRESS_COUNT_AT_LETTER_ORDER) {
    totalBusinessDays += ADD_PRINTING_NUMBER_OF_BUSINESS_DAYS_FOR_BULK_LETTER_ORDER;
  } else {
    totalBusinessDays += ADD_MAX_PRINTING_NUMBER_OF_BUSINESS_DAYS_FOR_CONGESTION;
  }

  return totalBusinessDays;
}

/**
 * 発送予定日までに必要な営業日数を取得する
 * @param {int} currentOrderAddressCount
 * @return {int}
 */
export const getAddBusinessDaysUntilShippingSchedule = (currentOrderAddressCount) => {
  let totalBusinessDays = getMinBusinessDaysUntilShippingSchedule();

  if (currentOrderAddressCount >= MIN_ORDER_ADDRESS_COUNT_AT_LETTER_ORDER) {
    totalBusinessDays += ADD_PRINTING_NUMBER_OF_BUSINESS_DAYS_FOR_BULK_LETTER_ORDER;
  }

  return totalBusinessDays;
}

/**
 * 営業日数を加算する
 * @param {string} date 日付の文字列
 * @param {int} days 上記の日付から数えた営業日の日数
 * @return {moment} momentオブジェクト
 */
export const addBusinessDays = (date, days) => {
  let now = moment().format("YYYY-MM-DD HH:mm:ss");

  // 注文予定日を変更後、元の注文予定日に変更した場合"YYYY-MM-DD 09:00:00"となってしまい
  // 現在時刻が午後の場合は発送予定日が1営業日早くなってしまうしまうため現在時刻を設定する
  if (
    (moment(now).hour(0).minutes(0).seconds(0)) // 実行時間の日付00:00:00
      .diff(date, 'days') === 0
  ) {
    date = now;
  }

  let curDate = moment(date);

  let validDays = 0;

  while (validDays < days) {
    let day = curDate.day();
    let key = curDate.format("YYYY-MM-DD");

    // 0が日曜日,6が土曜日
    const sundayCount = 0;
    const saturdayCount = 6;
    if (day !== sundayCount && day !== saturdayCount && !HOLIDAYS_JP.hasOwnProperty(key)) {
      validDays++;
    }

    if (validDays === days) {
      break;
    } else {
      curDate.add(1, "day");
    }
  }

  return curDate;
};



// WEBPACK FOOTER //
// ./src/utils/sendLetterUtils.js